import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './Component/Header';
import Footer from './Component/Footer';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import WhatsAppWidget from './Component/WhatsAppWidget';
import CookieConsent from "./Component/CookieConsent";
import ServiceDetail from './pages/ServiceDetail';
import ProjectDetailsPage from './pages/ProjectDetailsPage';
import FAQPage from './pages/Faq';
import ScrollToTop from './Component/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
                    <Route path="/faq" element={<FAQPage />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
  <Route path="/project" element={<Projects />} />
          
          {/* No props needed here either! */}
          <Route path="/project/:projectId" element={<ProjectDetailsPage />} />


        </Routes>
      </main>
            <ScrollToTop />

      <Footer />
      <WhatsAppWidget />
      <CookieConsent />

    </BrowserRouter>
  );
}

export default App;